import { createContext } from 'react';

import { ImportConfigurationContextType } from './types';

export const ImportConfigurationContext = createContext<
  ImportConfigurationContextType | undefined
>(undefined);
